<template>
    <a href="#" class="dropdown-item" @click.prevent>
        <slot/>
    </a>
</template>
<script>
export default {
    name: "DropdownItem",
}
</script>